import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = ({ slogan = '', leftContent, rightContent }) => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="app-header">
      {leftContent && <div className="app-header-left">{leftContent}</div>}
      <div className="app-header-brand">
        <img src="/myhelpz-logo.png" alt="MYHELPZ" className="app-logo" />
        {slogan && <p className="app-header-slogan">{slogan}</p>}
      </div>
      <div className="app-header-spacer" />
      {isAdmin && pathname === '/home' && (
        <button
          className="admin-link-btn"
          onClick={() => navigate('/myhelpz-admin')}
          title="Open Admin Dashboard"
        >
          ⚙ Admin
        </button>
      )}
      {rightContent && <div className="app-header-right">{rightContent}</div>}
    </header>
  );
};

export default Header;
